import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, CardText, CardTitle, DashboardSection, Header1 } from 'fiducius-ui';
import { isStringWithContent } from '../../../utils';
import { withPermissions } from '../../../routing';
import { NeedAssistance } from '../../../need-assistance';
import Scheduler from '../../../meetings/containers/scheduler';
import FaqQuestion from '../../../faq/components/faq-question';

const TRNeedAssistance = ({ permissions, needAssistanceObject }) => {
  const TRAssistanceObject =
    needAssistanceObject.length &&
    needAssistanceObject.find((element) => {
      return element.id === 'TR_Assistance';
    });
  const TRMessagePromptObject =
    needAssistanceObject.length &&
    needAssistanceObject.find((element) => {
      return element.id === 'TRMessagePrompt';
    });
  const needAssistanceText = TRAssistanceObject && TRAssistanceObject.messageContent;
  const needAssistanceAvatarLink = TRAssistanceObject && TRAssistanceObject.avatarLink;
  const needAssistancePrompt = TRMessagePromptObject && TRMessagePromptObject.messageContent;
  const blocktext =
    isStringWithContent(needAssistanceText) ||
    isStringWithContent(needAssistanceAvatarLink) ||
    isStringWithContent(needAssistancePrompt)
      ? 'block'
      : 'none';

  const showSpeakToAnExpertButton = () => {
    if (permissions.clientStatus === 'FUPHB' && permissions.enterpriseEnabled) {
      return true;
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-lg-12">
        <DashboardSection>
          <div className="row">
            <div className="col-12 col-lg-9">
              <Header1>Need Assistance?</Header1>
            </div>

            {showSpeakToAnExpertButton() && (
              <>
                <div className="col-12 col-lg-3" style={{ 'text-align': 'right' }}>
                  <Scheduler buttonText="Speak to an Expert" />
                </div>
              </>
            )}
          </div>
          <NeedAssistance messageType={'TRAlertPrompt'} />
          <Card style={{ display: blocktext }}>
            <CardBody>
              <CardTitle>Information</CardTitle>
              <CardText>
                <NeedAssistance messageType={'TR_Assistance'} />
                <NeedAssistance messageType={'TRMessagePrompt'} />
              </CardText>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <CardTitle>FAQs</CardTitle>
              <FaqQuestion question={'What institutions can you enroll in?'}>
                <p>
                  You can enroll in any institution accredited by the Department of Education's
                  Office of Post-secondary Education.
                </p>
              </FaqQuestion>
              <FaqQuestion question={'Can I receive reimbursement for certifications?'}>
                <p>
                  If certifications are eligible per your employer’s tuition reimbursement policy,
                  you can receive reimbursement for them.
                </p>
              </FaqQuestion>
              <FaqQuestion question={'When can you enroll in this benefit?'}>
                <p>
                  You can enroll at any point until your employer's budgetary limit for the benefit
                  is reached.
                </p>
              </FaqQuestion>
              <FaqQuestion
                question={'What is the maximum amount of money you can request in a calendar year?'}
              >
                <p>
                  Your maximum allotment can be found on your Tuition Overview page in the Summary
                  Information Section of your Portal.
                </p>
              </FaqQuestion>
              <FaqQuestion question={'When are payments sent?'}>
                <p>See Tuition Reimbursement Processing Section of Quick Ref Guide.</p>
              </FaqQuestion>
              <FaqQuestion
                question={'When will you get reimbursed for your degree(s) or certification(s)?'}
              >
                <p>
                  You will be reimbursed after the necessary information has been received and
                  reviewed. Once approved you will receive your reimbursement shortly thereafter.
                </p>
              </FaqQuestion>
            </CardBody>
          </Card>
        </DashboardSection>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  todos: Object.values(state.todos.cache),
  needAssistanceObject: Object.values(state.needAssistance.cache),
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withPermissions(TRNeedAssistance));
